module.exports = __webpack_public_path__ + "static/img/Hayal45.2f6487c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-45/Hayal45.png
// module id = qA2J
// module chunks = 6